<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <div class="mt-2"/>
      <v-layout row class="ml-3 mt-3 mr-3">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Process
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
            <v-icon>
              {{this.trans.flow[this.trans.flow.length - 1].icon}}
            </v-icon>
          </v-avatar>
          {{this.trans.flow[this.trans.flow.length - 1].title}}
        </v-chip>
        <div class="hidden-sm-and-down">
          <TransitionsStats/>
        </div>
      </v-layout>
      <v-layout class="ml-4 mr-4">
        <v-progress-linear
          height="3"
          :background-color="ui.colorBlue"
          :color="ui.colorSuccess"
          :value="calcTransionsProgressBar()"
        ></v-progress-linear>
      </v-layout>
      <v-layout row class="ml-3 mt-3 mr-3">
        <v-flex xs11 offset-xs1>
          <v-layout row class="mr-2">
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>create</v-icon>
                </v-avatar>
                Initial
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
              class="hidden-md-and-down">
                <v-avatar>
                <v-icon>today</v-icon>
                </v-avatar>
                {{dateTypeA(this.trans.flow[this.trans.flow.length - 1].date)}}
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                  <v-icon>
                    {{this.trans.flow[0].icon}}
                  </v-icon>
                </v-avatar>
                {{this.trans.flow[0].title}}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row class="ml-3 mr-3"
      v-if="this.trans.flow.length > 2">
        <v-flex xs11 offset-xs1>
          <v-layout row class="mr-2">
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>history</v-icon>
                </v-avatar>
                Prior
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
              class="hidden-md-and-down">
                <v-avatar>
                <v-icon>today</v-icon>
                </v-avatar>
                {{dateTypeA(this.trans.flow[this.trans.flow.length - 2].date)}}
              </v-chip>
            </v-flex>
            <v-flex xs4>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                  <v-icon>
                    {{this.trans.flow[this.trans.flow.length - 2].icon}}
                  </v-icon>
                </v-avatar>
                {{this.trans.flow[this.trans.flow.length - 2].title}}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- <v-layout row class="ml-3 mt-3 mr-3 hidden-sm-and-down">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Business Process Review - {{defineTransInfo(this.trans.level - 1, this.trans.model).title}}
        </v-chip>
        <v-spacer/>
      </v-layout> -->
      <v-layout row class="ml-3 mt-3 mr-3">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Business Process Review
        </v-chip>
        <v-spacer/>
      </v-layout>
      <v-layout row class="mb-2 ml-1" :class="ui.textDescription">
        <v-flex xs10 offset-xs1>
          {{defineTransInfo(this.trans.level - 1, this.trans.model).comn}}
        </v-flex>
      </v-layout>
      <v-layout row class="mr-4">
        <v-spacer/>
        <v-layout row justify-end class="mt-1 mr-4 mb-4">
          <TransitionsList :data="{type: 'flow'}"/>
          <div class="mr-4"/>
          <TransitionsList :data="{type: 'history'}"/>
        </v-layout>
      </v-layout>
      <div v-if="revertEnabled || approvalEnabled">
        <v-layout row class="ml-4"
        v-if="
        (this.tag !== 'G1' && this.trans.level !== 0)||
        (this.tag === 'G1' && this.trans.level < 2)">
          <v-flex xs10 offset-xs1>
            <v-textarea
             v-model="transitionComments"
             :disabled="false"
             :outline="true"
             :rules="ruleMustBeNotUndefinedANDLessThan1000"
             hint="type comments to unlock approve or revert buttons"
             auto-grow
             persistent-hint
             ></v-textarea>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="this.trans.flow[this.trans.flow.length - 1].title !== 'Complete'">
        <v-layout row class="ml-3 mr-3"
        v-if="this.trans.flow.length < this.defineTransSize(this.trans.model)">
          <v-flex xs10 offset-xs2>
            <v-layout row class="mr-2">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon>update</v-icon>
                </v-avatar>
                Next - {{defineTransInfo(this.trans.flow.length, this.trans.model).title}}
              </v-chip>
              <v-spacer/>
              <!-- <TransitionsCancel :data="{level: trans.level, comm: transitionComments}"/> -->
              <v-btn
               @click="startCancelProcess(trans.level, transitionComments)"
               :color="ui.colorBkgd"
               icon
               :disabled="this.transitionComments === '' || this.cancelActive"
               v-if="true"
              >
                <v-icon :color="ui.colorWarning"> block </v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row class="ml-3 mr-3"
      v-if="this.trans.flow[this.trans.flow.length - 1].title === 'Complete'">
        <v-flex xs10 offset-xs2>
          <v-layout row>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon :color="ui.colorWarning">warning</v-icon>
              </v-avatar>
              <div :class="ui.textSubheadingWarning">
                Upload will lock the Process.
              </div>
            </v-chip>
            <v-spacer/>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="hidden-xs-only">
        <v-layout wrap row align-center justify-centre fill-height class="mt-4 mr-4">
          <v-spacer/>
          <v-btn
           @click="revertTranistion(trans.level, transitionComments)"
           :color="ui.colorError"
           outline
           :disabled="this.transitionComments === '' || this.cancelActive"
           v-if="revertEnabled"
          >
            <v-icon left> settings_backup_restore </v-icon>
              revert
          </v-btn>
          <v-btn
           @click="progressTranistion(true, trans.level, transitionComments)"
           :color="approvalBtn.color"
           outline
           :disabled="this.transitionComments === '' || this.cancelActive"
           v-if="approvalEnabled"
          >
            <v-icon left> {{approvalBtn.icon}} </v-icon>
              {{approvalBtn.title}}
          </v-btn>
        </v-layout>
      </div>
      <div class="hidden-sm-and-up">
        <v-layout row class="mt-4 mr-4">
          <v-spacer/>
          <v-btn
           @click="progressTranistion(true, trans.level, transitionComments)"
           :color="approvalBtn.color"
           outline
           :disabled="this.transitionComments === '' || this.cancelActive"
           v-if="approvalEnabled"
          >
            <v-icon left> {{approvalBtn.icon}} </v-icon>
              {{approvalBtn.title}}
          </v-btn>
        </v-layout>
        <v-layout row class="mt-4 mr-4">
          <v-spacer/>
          <v-btn
           @click="revertTranistion(trans.level, transitionComments)"
           :color="ui.colorError"
           outline
           :disabled="this.transitionComments === '' || this.cancelActive"
           v-if="revertEnabled"
          >
            <v-icon left> settings_backup_restore </v-icon>
              revert
          </v-btn>
        </v-layout>
      </div>
      <v-layout row class="mt-2 mr-4">
        <v-spacer/>
        <v-btn
         @click="holdTransition(!trans.stat.hold, transitionComments)"
         :color="holdBtn.color"
         outline
         :disabled="this.transitionComments === ''"
         v-if="holdBtnEnabled"
        >
          <v-icon left> {{holdBtn.icon}} </v-icon>
            {{holdBtn.title}}
        </v-btn>
      </v-layout>
      <v-layout row class="mr-2 mt-3" v-if="this.cancelActive">
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon :class="ui.textWarning"> warning </v-icon>
          </v-avatar>
          <span :class="ui.textWarning">
            Cancel process is not reversible.
          </span>
        </v-chip>
        <v-spacer/>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import TransitionsList from "@/support/transitions/components/TransitionsList";
import TransitionsStage from "./TransitionsStage";
import TransitionsStats from "./TransitionsStats";
// import TransitionsCancel from "./TransitionsCancel";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import transOptions from "@/support/transitions/mixins/transOptions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";
export default {
  components: {
    // eslint-disable-next-line
    TransitionsStage,
    TransitionsStats,
    // TransitionsCancel,
    TransitionsList
  },
  // eslint-disable-next-line
  mixins: [
    rulesTextfield,
    dateFunctions,
    apptheme,
    transFunctions,
    transOptions,
    announcements
  ],
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getTransitions",
      "getCurrentPage",
      "getDetail",
      "getUser",
      "getDetailSelect"
    ]),
    trans() {
      return this.getTransitions;
    },
    tag() {
      return this.getDetail.basic.tag;
    },
    approvalEnabled() {
      if (
        this.trans.level > 0 &&
        this.trans.level < this.defineMaxProcessStep(this.trans.model)
      ) {
        return true;
      } else {
        return false;
      }
    },
    cancelActive() {
      let status = this.trans.flow[this.trans.flow.length - 1].title;
      if (status === "Cancelled" || this.cancelBtnPressed === true) {
        return true;
      } else {
        return false;
      }
    },
    revertEnabled() {
      // eslint-disable-next-line
      let status = this.trans.flow[this.trans.flow.length - 1].title;
      if (
        this.trans.level > 1 &&
        this.trans.stat.cancel === false &&
        this.trans.stat.hold === false &&
        status !== "Closed"
      ) {
        return true;
      } else {
        return false;
      }
    },
    holdBtnEnabled() {
      if (
        this.trans.level === 1 &&
        this.getDetail.basic.tag === "G1" &&
        this.getDetail.basic.tagd === "U1"
      ) {
        return true;
      } else if (
        this.trans.level == 1 &&
        this.getDetail.basic.tag === "G1" &&
        this.getDetail.basic.tagd === "Z5"
      ) {
        return true;
      } else if (
        this.trans.level > 0 &&
        (this.tag === "G1" && this.trans.level < 2) &&
        this.trans.level < this.defineMaxProcessStep(this.trans.model) &&
        this.trans.stat.cancel === false &&
        this.trans.stat.hold === false
      ) {
        return true;
      } else {
        return false;
      }
    },
    approvalAccessEnabled() {
      if (this.trans.level > 0 && this.tag === "G1" && this.trans.level !== 3) {
        return true;
      } else {
        return false;
      }
    },
    holdBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.trans.stat.hold === false) {
        obj.title = "info";
        obj.icon = "add";
        obj.color = this.ui.colorWarning;
      } else if (this.trans.stat.hold === true) {
        obj.title = "info";
        obj.icon = "add";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "approve";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    approvalBtn() {
      // eslint-disable-next-line
      let status = this.getTransitions.flow[this.getTransitions.flow.length - 1].title;
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag !== null && status !== "Cancelled") {
        obj.title = "approve";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      } else if (this.tag !== null && status === "Cancelled") {
        obj.title = "cancelled";
        obj.icon = "block";
        obj.color = this.ui.colorWarning;
      } else {
        obj.title = "undefined ";
        obj.icon = "done";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    revertBtn() {
      let obj = {
        icon: "",
        title: "",
        color: ""
      };
      if (this.tag !== null) {
        obj.title = "restart_alt";
        obj.icon = "revert";
        obj.color = this.ui.colorSuccess;
      }
      return obj;
    },
    cancelEnabled() {
      let k = this.trans.steps - 1;
      if (
        this.trans.level > 1 &&
        this.tag === "A1" &&
        this.trans.cancel === false &&
        this.trans.level < k
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    changeUnsavedStatusIndication() {
      if (this.getCurrentPage === "/procedureview") {
        this.$store.dispatch("changeUnsavedProcedureIndication", true);
      }
      if (this.getCurrentPage === "/maintplanedit") {
        this.$store.dispatch("changeUnsavedMaintPlanIndication", true);
      }
    },
    startCancelProcess(lev, comm) {
      this.cancelTranistion(lev, comm);
      let msg = "";
      msg = "Document cancel process started. ";
      this.generateInfoSnackbar(this.ui.colorWarning, msg);
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      cancelBtnPressed: false,
      cancelLocked: false,
      iconInfoForNextStep: "contact_support",
      transitionComments: ""
    };
  }
};
</script>
